import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-62f440f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-learn-cards",
  "aria-labelledby": "learn-title"
};
const _hoisted_2 = {
  class: "learn-shell"
};
const _hoisted_3 = {
  class: "learn-heading"
};
const _hoisted_4 = {
  id: "learn-title"
};
const _hoisted_5 = {
  class: "view-all-articles"
};
const _hoisted_6 = {
  class: "learn-grid"
};
const _hoisted_7 = {
  class: "article-copy"
};
const _hoisted_8 = {
  class: "article-badge"
};
const _hoisted_9 = {
  class: "article-art",
  "aria-hidden": "true"
};
const _hoisted_10 = ["src"];
import { computed } from 'vue';
import { ArrowRightOutlined } from '@ant-design/icons-vue';
import { useI18n } from 'vue-i18n';
import web3Image from '@/assets/home1/article-web3.png';
import securityImage from '@/assets/home1/article-security.png';
import earnImage from '@/assets/home1/article-earn.png';
import chainImage from '@/assets/home1/article-chain.png';
export default {
  __name: 'HomeLearnCards',
  setup(__props) {
    const {
      t
    } = useI18n();
    const articles = computed(() => [{
      id: 'web3',
      category: t('homepage.learn.articles.web3.category'),
      title: t('homepage.learn.articles.web3.title'),
      description: t('homepage.learn.articles.web3.description'),
      image: web3Image
    }, {
      id: 'stake',
      category: t('homepage.learn.articles.stake.category'),
      title: t('homepage.learn.articles.stake.title'),
      description: t('homepage.learn.articles.stake.description'),
      image: earnImage
    }, {
      id: 'security',
      category: t('homepage.learn.articles.security.category'),
      title: t('homepage.learn.articles.security.title'),
      description: t('homepage.learn.articles.security.description'),
      image: securityImage
    }, {
      id: 'chain',
      category: t('homepage.learn.articles.chain.category'),
      title: t('homepage.learn.articles.chain.title'),
      description: t('homepage.learn.articles.chain.description'),
      image: chainImage
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("header", _hoisted_3, [_createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)('homepage.learn.title')), 1), _createElementVNode("span", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_unref(t)('homepage.learn.viewAll')), 1), _createVNode(_unref(ArrowRightOutlined), {
        "aria-hidden": "true"
      })])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articles), article => {
        return _openBlock(), _createElementBlock("article", {
          key: article.id,
          class: _normalizeClass(["learn-card", `learn-card--${article.id}`])
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(article.category), 1), _createElementVNode("h3", null, _toDisplayString(article.title), 1), _createElementVNode("p", null, _toDisplayString(article.description), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          src: article.image,
          alt: ""
        }, null, 8, _hoisted_10)])], 2);
      }), 128))])])]);
    };
  }
};